import { IconsType } from '../../shared/Icon'

export const STORAGE_KEY_MIC = 'dictation-selected-mic'
export const STORAGE_KEY_MODE = 'dictation-widget-mode'
export const BAR_HEIGHT = 46
export const PANEL_HEIGHT = 220
export const STATS_PANEL_WIDTH = 460
export const STATS_PANEL_HEIGHT = 420

export type ModeId = 'dictation' | 'notepad' | 'stats'

export type ModeConfig = {
  id: ModeId
  label: string
  hint: string
  iconName: IconsType
}

/** Valeurs de `data-state` de la pastille du bouton principal (styles dans DictationWidget.module.scss). */
export type DictationButtonState =
  | 'idle'
  | 'disabled'
  | 'connecting'
  | 'error'
  | 'recordingTargeted'
  | 'recordingUntargeted'
  | 'recordingWarning'
  | 'recordingTooNoisy'

export type StatsButtonState = 'idle' | 'statsProcessing' | 'statsResultReady'

const BASE_MODES: ModeConfig[] = [
  {
    id: 'dictation',
    label: 'Dictée',
    hint: 'Transcription dans le champ actif',
    iconName: 'dictation',
  },
  {
    id: 'notepad',
    label: 'Bloc-notes',
    hint: 'Zone libre, navigation conservée',
    iconName: 'scribe',
  },
]

const STATS_MODE: ModeConfig = {
  id: 'stats',
  label: 'Statistiques',
  hint: 'Interroger vos données patients en langage naturel',
  iconName: 'dashboard',
}

export const getAvailableModes = (
  statsEnabled: boolean,
  voiceDictationEnabled: boolean,
): ModeConfig[] => {
  const modes: ModeConfig[] = []
  if (voiceDictationEnabled) modes.push(...BASE_MODES)
  if (statsEnabled) modes.push(STATS_MODE)
  return modes
}

/** Never return a mode that is not currently available (flags load after first paint). */
export const resolveWidgetMode = (saved: string | null, availableModes: ModeConfig[]): ModeId => {
  if (saved && availableModes.some((m) => m.id === saved)) {
    return saved as ModeId
  }
  return availableModes[0]?.id ?? 'dictation'
}
